import http from './http'

export function verifySN(data) {
  return http.post('/api/verify', data)
}
